import createAPIServices from './createAPIServices'

const api = createAPIServices()

// api phần user
export const changePasswordAPI = (args = {}) => {
    return api.makeAuthRequest({
        url: `/users/changepass`,
        method: 'POST',
        data: args,
    })
}

export const updateUserInfoAPI = (uid, args = {}) => {
    return api.makeAuthRequest({
        url: `/users/${uid}`,
        method: 'PUT',
        data: args,
    })
}

export const updateUserStatusAPI = (uid, status) => {
    return api.makeAuthRequest({
        url: `/users/query?uid=${uid}&status=${status}`,
        method: 'PUT',
    })
}

export const getUserQueryAPI = (uid, username) => {
    return api.makeAuthRequest({
        url: `/users/query?uid=${uid}&username=${username}`,
        method: 'GET',
    })
}

export const getListUserAPI = (last_id, count, status) => {
    return api.makeAuthRequest({
        url: `users?last_id=${last_id}&count=${count}&status=${status}`,
        method: 'GET',
    })
}

export const createUserAPI = (args = {}) => {
    const formData = new FormData()
    for (let key in args) {
        formData.append(key, args[key])
    }
    return api.makeAuthRequest({
        url: '/users/create',
        method: 'POST',
        data: formData,
    })
}

// auth
export const loginAPI = (uname, password) => {
    const body = {
        password: password,
        user_name: uname,
    }
    return api.makeRequest({
        url: 'users/login',
        method: 'POST',
        data: body,
    })
}

export const logout = () => {
    return api.makeAuthRequest({
        url: 'users/logout',
        method: 'POST',
    })
}

export const getUserInfo = () => {
    return api.makeAuthRequest({
        url: '/users/profile',
        method: 'GET',
    })
}
export const getUserInfoByid = uid => {
    return api.makeAuthRequest({
        url: `/users/query?uid=${uid}`,
        method: 'GET',
    })
}
